'use strict';
const angular = require('angular');

/*@ngInject*/
export function subjectsService(Util, common, $http, $timeout) {
  var safeCb = Util.safeCb;
  var subjects = [];
  var initialised = false;

  return {
    initialise(callbackSuccess, callbackError) {
      var that = this;
      common.setLoading(true);
      if(!initialised) {
        var promise = $http.get('/api/subjects/load');
        promise.then(response => {
          try {
            subjects = response.data;
            common.setQuickNotification('subjects loaded', 'success');
            initialised = true;
            try {
              this.setupMidHighLow();
              console.log(subjects);
            } catch (e) {
              console.log(e.message);
            }
            safeCb(callbackSuccess)(subjects);
          } catch(e) {
            console.log(e);
            common.setQuickNotification('Error loading subjects', 'danger');
            safeCb(callbackError)(err);
          }
        }).catch(err => {
          if(err.status != 401 && err.status != 404) {
            common.setAlert('Error', 'danger', `Error getting subjects. Please try again. (Error ${err.status}: ${err.statusText})`, false, true);
          }
          if (err.status == 404) {
            common.setQuickNotification('No subjects found', 'danger');
          }
          if(callbackError) {
            safeCb(callbackError)(err.data);
          } else if(callbackSuccess) {
            safeCb(callbackSuccess)(err.data);
          }
        });
      } else {
        safeCb(callbackSuccess)(subjects);
      }
    },

    setupMidHighLow() {
      for(var i=0;i<subjects.length;i++) {
        for (var j=0; j<subjects[i].scales.length;j++){
          var random = Math.random();
          subjects[i].scales[j].midhigh = subjects[i].scales[j].min + Math.ceil((subjects[i].scales[j].max - subjects[i].scales[j].min)/2);
          subjects[i].scales[j].midlow = subjects[i].scales[j].min + Math.floor((subjects[i].scales[j].max - subjects[i].scales[j].min)/2);
        }
      }
    },

    setupMidPoint() {
      for(var i=0;i<subjects.length;i++) {
        for (var j=0; j<subjects[i].scales.length;j++){
          var random = Math.random();
          if (random > 0.5){
            subjects[i].scales[j].score = 1; //subjects[i].scales[j].midhigh;
          } else {
            subjects[i].scales[j].score = 1; //subjects[i].scales[j].midlow;
          }
        }
      }
    },

    weightScores(oSubjects, callbackSuccess, callbackError) {
      try{
        for(var i=0;i<oSubjects.length;i++) {
          oSubjects[i].weightedCalc = 0;
          oSubjects[i].noOfNotBothered = 0;
          for (var j=0; j<oSubjects[i].scales.length;j++){
            if (!oSubjects[i].scales[j].notbothered) {
              if (oSubjects[i].scales[j].score == oSubjects[i].scales[j].midhigh) {
                oSubjects[i].scales[j].weightedCalc = oSubjects[i].scales[j].score + 1
              } else if (oSubjects[i].scales[j].score == oSubjects[i].scales[j].midlow) {
                oSubjects[i].scales[j].weightedCalc = oSubjects[i].scales[j].score - 1;
              } else {
                oSubjects[i].scales[j].weightedCalc = oSubjects[i].scales[j].score;
              }
              if ((oSubjects[i].scales[j].weightedCalc <= oSubjects[i].scales[j].midlow) && (i === 0 || i === 1)) {
                oSubjects[i].scales[j].weightedCalc = oSubjects[i].scales[j].weightedCalc - 1;
                if (oSubjects[i].scales[j].weightedCalc < subjects[i].scales[j].min) oSubjects[i].scales[j].weightedCalc = subjects[i].scales[j].min;
              }
              if ((oSubjects[i].scales[j].weightedCalc >= oSubjects[i].scales[j].midhigh) && (i === 0 || i === 1)) {
                oSubjects[i].scales[j].weightedCalc = oSubjects[i].scales[j].weightedCalc + 1;
                if (oSubjects[i].scales[j].weightedCalc > subjects[i].scales[j].max) oSubjects[i].scales[j].weightedCalc = subjects[i].scales[j].max;
              }
              oSubjects[i].weightedCalc += oSubjects[i].scales[j].weightedCalc;
            } else {
              oSubjects[i].noOfNotBothered++;
              oSubjects[i].scales[j].weightedCalc = 3;
            }
          }
        }
        safeCb(callbackSuccess)(oSubjects);
      } catch(e) {
        safeCb(callbackError)(e.message);
      }
    },

    getSubjects() {
      return subjects;
    }
  };
}

export default angular.module('ffApp.subjects', [])
  .service('subjects', subjectsService)
  .name;



// WEBPACK FOOTER //
// ./client/components/subjects/subjects.service.js